export enum ClientModalNames {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    INFO = 'INFO',
}